export const questions: Array<[string, string]> = [
  [
    'Per chi è questa collezione?',
    'Per docenti di scuola secondaria, istituti tecnici e università che vogliono spiegare l’industria del petrolio e del gas in modo chiaro e pronto all’uso.',
  ],
  ['In che formato ricevo il materiale?', 'In PDF scaricabili, da consultare su computer, tablet o da stampare.'],
  ['Quando ricevo l’accesso?', 'Subito dopo il pagamento ricevi via email il link di accesso immediato.'],
  [
    'Serve una preparazione specifica sul settore petrolifero?',
    'No, i contenuti partono dalle basi e arrivano ai temi più avanzati in modo progressivo.',
  ],
  [
    'Posso usarlo con i miei studenti?',
    'Sì, è pensato per l’uso in classe: attività, casi di studio, verifiche e schede di sintesi pronte.',
  ],
  ['C’è una garanzia?', 'Sì, hai 7 giorni di garanzia di soddisfazione.'],
];
